import React, { useEffect } from 'react'
import { captureException } from '@sentry/react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

function RootErrorBoundary(): React.ReactElement {
  const error = useRouteError()
  // https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/#set-up-a-custom-error-boundary
  useEffect(() => {
    captureException(error)
  }, [error])

  if (isRouteErrorResponse(error)) {
    return (
      <div className="container p-3">
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </div>
    )
  } else if (error instanceof Error) {
    // Reload the page if a chunk is missing as this happens mostly due to deployments.
    if (
      error.message.startsWith('Failed to fetch dynamically imported module')
    ) {
      window.location.reload()
    }
    return (
      <div className="container p-3">
        <h1>Error</h1>
        <p>{error.message}</p>
        <p>The stack trace is:</p>
        <pre>{error.stack}</pre>
      </div>
    )
  } else {
    return (
      <div className="container p-3">
        <h1>Unknown Error</h1>
      </div>
    )
  }
}

export default RootErrorBoundary
